const nameRegex = /^[a-z ,.'-]+$/i;
export default nameRegex;
